"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultUserState = void 0;

var _auth = require("../api/auth");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultUserState = function defaultUserState() {
  return {
    token: null,
    groups: [],
    authLevel: -1,
    authed: false,
    attempts: 0,
    meta: [],
    id: null,
    isAuthenticating: false,
    email: null
  };
};

exports.defaultUserState = defaultUserState;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultUserState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _auth.IS_AUTHENTICATING:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isAuthenticating: true
        });
      }

    case _auth.UPDATE_USER:
      {
        return _objectSpread(_objectSpread({}, state), action.update);
      }

    case _auth.USER_LOGIN:
      {
        (0, _auth.setUserToken)(action.user);

        var newState = _objectSpread(_objectSpread(_objectSpread({}, state), action.user), {}, {
          authed: true,
          isAuthenticating: false
        });

        ++newState.attempts;
        return newState;
      }

    case _auth.AUTH_FAILURE:
      {
        (0, _auth.removeUserToken)();

        var _newState = defaultUserState();

        ++_newState.attempts;
        return _newState;
      }

    case _auth.USER_LOGOUT:
      {
        (0, _auth.removeUserToken)();
        return defaultUserState();
      }

    default:
      return state;
  }
};

exports["default"] = _default;